function updateMediaLibraryContent(data) {
  var listItems = data.listItems;
  $('.list-items__container').html('');
  $.each(listItems, function (index, listItem) {
    createMediaItemRow(listItem);
  });
}

function createMediaItemRow(item) {
  // Type
  var type = item.filename_full ? 'image' : 'document';

  // Select media
  var selectMedia = isSelectMediaEnabled();

  // Target
  var mlTarget = $('.list-items__container');

  // Container
  var mlListRowContainer = $(
    '<div class="list-item__row list-item__row--body"/>'
  );
  mlListRowContainer.attr('data-id', item.id);
  mlListRowContainer.appendTo(mlTarget);

  // Checkbox
  if (!selectMedia) {
    var mlListColMultiselect = $(
      '<div class="list-item__icon list-item__icon--multiselect icon-link noselect"/>'
    );
    mlListColMultiselect.on('click', function () {
      selectItem(item.id);
    });
    mlListColMultiselect.html(
      '<svg class="list-item__icon-image list-item__icon-image--checkbox-blank" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 5v14H5V5h14m2-2H3v18h18V3z"></path></svg><svg class="list-item__icon-image list-item__icon-image--checkbox-checked" width="24px" height="24px" viewBox="0 0 24 24"><path d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>'
    );
    mlListColMultiselect.appendTo(mlListRowContainer);
  }

  // Image
  var mlListColImage = $(
    '<' +
    (selectMedia
      ? 'div'
      : 'a href="/admin/media/' + type + '/edit/' + item.id) +
    '" class="list-item__column list-item__column--' +
    type +
    '"/>'
  );
  mlListColImage.attr('data-type', type);
  mlListColImage.attr('data-id', type);

  if (item.filename_small) {
    mlListColImage.html(
      '<div class="list-item__media-preview list-item__media-preview--image" style="background-image: url(\'/image/' +
      item.filename_small +
      '\')"></div>'
    );
  } else {
    mlListColImage.html(
      '<div class="list-item__media-preview list-item__media-preview--document" style="background-image: url(\'' +
      getFileExtensionImage(item.filename) +
      '\')"></div>'
    );
  }

  mlListColImage.appendTo(mlListRowContainer);

  // Title
  var mlListColTitle = $(
    '<' +
    (selectMedia
      ? 'div'
      : 'a href="/admin/media/' + type + '/edit/' + item.id) +
    '" class="list-item__column ' +
    (selectMedia ? '' : 'list-item__column--link') +
    '"/>'
  );
  mlListColTitle.attr('data-type', 'title');
  mlListColTitle.attr('data-id', 'title');
  mlListColTitle.html(item.title);
  mlListColTitle.appendTo(mlListRowContainer);

  // Change date
  var mlListColDate = $('<div class="list-item__column"/>');
  mlListColDate.attr('data-type', 'datetime');
  mlListColDate.attr('data-id', 'updated_at');
  var date = new Date(item.updated_at);

  date =
    ('0' + date.getDate()).slice(-2) +
    '.' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '.' +
    date.getFullYear() +
    ' ' +
    ('0' + date.getHours()).slice(-2) +
    ':' +
    ('0' + date.getMinutes()).slice(-2);

  mlListColDate.html(date);
  mlListColDate.appendTo(mlListRowContainer);

  var originalLink =
    type == 'image' ? '/image/' + item.filename_full : '/file/' + item.filename;

  if (type == 'image') {
    var mlListColActionTermsAccepted = $(
      '<div class="list-item__icon list-item__icon--terms-accepted' + (item.consent_available == '1' ? ' -accepted' : ' -not-accepted') + '"/>'
    );
    mlListColActionTermsAccepted.attr('data-tooltip-row', 'Einwilligungserklärungen' + (item.consent_available == '1' ? ' vorhanden' : ' nicht vorhanden'));
    mlListColActionTermsAccepted.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M23,11.99L20.56,9.2l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5l0.34,3.7L1,11.99l2.44,2.79l-0.34,3.7l3.61,0.82l1.89,3.2l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67L8,17.55l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65L3.67,12l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19l0.44-0.74l0.99-1.68L11.2,4.8L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68L16,6.45l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85l0.56,0.65l1.29,1.47L19.05,13.47z M10.09,13.75l-2.32-2.33l-1.48,1.49l3.8,3.81l7.34-7.36l-1.48-1.49L10.09,13.75z"></path></svg>'
    );
    mlListColActionTermsAccepted.appendTo(mlListRowContainer);
  }

  // Action view
  var mlListColActionView = $(
    '<a href="' +
    originalLink +
    '" target="_blank" class="list-item__icon list-item__icon--preview icon-link"/>'
  );
  mlListColActionView.attr('data-tooltip-row', 'Öffnen');
  mlListColActionView.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path></svg>'
  );
  mlListColActionView.appendTo(mlListRowContainer);

  if (!selectMedia) {
    // Action download
    var mlListColActionDownload = $(
      '<a href="' +
      originalLink +
      '" download="' +
      item.filename_original +
      '" class="list-item__icon list-item__icon--download icon-link"/>'
    );
    mlListColActionDownload.attr('data-tooltip-row', 'Herunterladen');
    mlListColActionDownload.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19,9h-4V3H9v6H5l7,7L19,9z M5,18v2h14v-2H5z"></path></svg>'
    );
    mlListColActionDownload.appendTo(mlListRowContainer);

    // Action edit
    var mlListColActionEdit = $(
      '<a href="/admin/media/' +
      type +
      '/edit/' +
      item.id +
      '" class="list-item__icon list-item__icon--edit icon-link"/>'
    );
    mlListColActionEdit.attr('data-tooltip-row', 'Bearbeiten');
    mlListColActionEdit.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"></path></svg>'
    );
    mlListColActionEdit.appendTo(mlListRowContainer);

    // Action delete
    var hasReferences = item.references && item.references.length;
    var mlListColActionDelete = $(
      '<div class="list-item__icon list-item__icon--delete icon-link' +
      (hasReferences ? ' icon-link--gray icon-link--red' : '') +
      '"/>'
    );
    mlListColActionDelete.attr('data-tooltip-row', 'Unwiderruflich löschen');
    mlListColActionDelete.attr(
      'data-references',
      hasReferences ? item.references.length : 0
    );

    mlListColActionDelete.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M6 21h12V7H6v14zm2.46-9.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5z"></path></svg>'
    );
    mlListColActionDelete.on('click', function () {
      deleteItem(
        item.id,
        type == 'image' ? 'Image' : 'Document',
        true,
        'ml-' + type
      );
    });
    mlListColActionDelete.appendTo(mlListRowContainer);
  }

  if (selectMedia) {
    var mlListColSelectMedia = $(
      '<div class="list-item__icon list-item__icon--select-media button button--small"/>'
    );
    mlListColSelectMedia.html(
      '<span>Auswählen</span>'
    );
    mlListColSelectMedia.on('click', function () {
      var data = {
        mediaLibraryId: item.media_library_id,
        values: {
          title: item.title
        }
      };

      if (type == 'image') {
        data.uri = '/image/' + item.filename_full;
        data.uriThumb = '/image/' + item.filename_small;
        data.altTitleEnabled = item.alt_title_enabled;
        data.values.altTitle = item.alt_title;
        data.values.author = item.author;
      } else {
        data.uri = '/file/' + item.filename;
      }

      app.selectMediaCallback(data);
      closeMediaLibrary();
    });
    mlListColSelectMedia.appendTo(mlListRowContainer);
  }

  // Attach tooltips
  app.tooltipRow.attach();
}
